import { Component } from '@angular/core';
import { soundpostReportOutputDeferredRevenueSummaryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Deferred Revenue Summaries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputdeferredrevenuesummary-form',
    templateUrl: './soundpostreportoutputdeferredrevenuesummary.form.component.html'
})
export class soundpostReportOutputDeferredRevenueSummaryFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputDeferredRevenueSummaryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

